<template>
  <div class="cell-edit">
    <transition name="fade" mode="out-in">
        <div v-if="!edit" key="value" @dblclick="showEdit" class="cell-edit__value test-button-edit-remark">
            <span v-if="textVal.length !== 0">{{ textVal }}</span>
            <span class="placeholder" v-else>{{ $t('dashboard.remark.double_click') }}<br/>{{ $t('dashboard.remark.to_add') }}</span>
        </div>
      <div v-else class="cell-edit__input" key="edit">
        <input class="input" v-model="val" />
        <button class="cell-edit__input__save" @click="save">
          <BaseIcon icon="check" />
        </button>
        <button class="cell-edit__input__cancel" @click="cancel">
          <BaseIcon icon="cancel" />
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'BaseInputCell',
  props: {
    value: {
      type: String | Number,
      default: '',
    },
  },
  data() {
    return {
      val: this.value,
      edit: false,
    };
  },
  computed: {
    textVal() {
      return (this.val.length > 35) ? `${this.val.substring(0, 32)}..` : this.val;
    },
  },
  watch: {
    value() {
      this.val = this.value;
    },
  },
  methods: {
    save() {
      // todo save
      this.$emit('onChange', this.val);
      this.edit = false;
    },
    cancel() {
      this.edit = false;
      this.val = this.value;
    },
    showEdit() {
      this.edit = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.cell-edit {
  align-self: center;
  height: 4.5rem;
  display: flex;
  align-items: stretch;
  width: 90%;
  margin-left: -0.5rem;
  min-width: 10em;

  &__value {
    padding: 0 0.5rem;
    width: 100%;
    display: flex;
    align-items: center;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: all 0.4s;

    &:hover {
      background-color: #f5f5f5;
    }
    .placeholder {
      color:rgba(172,180,197,0.35);
    }
  }

  &__input {
    position: relative;

    .input {
      padding-right: 3rem;
    }

    button {
      border: none;
      color: white;
      font-weight: 600;
      font-size: 1rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      right: 0;
      height: 50%;
      width: 3rem;
      position: absolute;
    }

    &__save {
      top: 0;
      background-color: $company-color;
      border-radius: 0 0.5rem 0 0;

      &:hover {
        background-color: darken($company-color, 10%);
      }

      .icon {
        fill: white;
        width: 1.2rem;
        height: 1.2rem;
      }
    }

    &__cancel {
      bottom: 0;
      background-color: #bec4d3;
      border-radius: 0 0 0.5rem 0;

      &:hover {
        background-color: darken(#bec4d3, 10%);
      }

      .icon {
        fill: white;
        width: 1rem;
        height: 1rem;
      }
    }
  }
}
</style>
